import { BaseError } from './base.js';
export class NotFoundError extends BaseError {
    httpStatus = 404;
}
